import React from 'react';

const TermsPage = () => {
  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-[#007dc6] mb-8">Términos y Condiciones</h1>
        
        <div className="prose prose-lg text-gray-600">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar los servicios de Steps Colombia SAS, usted acepta estar sujeto a estos términos y condiciones. 
              Si no está de acuerdo con alguna parte de los términos, no debe utilizar nuestros servicios.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Uso del Servicio</h2>
            <p>
              Los servicios proporcionados por Steps Colombia SAS están destinados únicamente para uso personal o comercial legítimo. 
              Queda prohibido cualquier uso que viole leyes locales, nacionales o internacionales.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Propiedad Intelectual</h2>
            <p>
              Todo el contenido, logotipos, gráficos y software asociado con nuestros servicios son propiedad de Steps Colombia SAS 
              o de sus licenciantes y están protegidos por leyes de derechos de autor y marcas registradas.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Limitación de Responsabilidad</h2>
            <p>
              Steps Colombia SAS no será responsable por daños indirectos, incidentales, especiales o consecuentes que resulten del 
              uso o la imposibilidad de uso de nuestros servicios.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Las versiones actualizadas serán publicadas 
              en nuestro sitio web con la fecha de la última revisión.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;